class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.form = this.querySelector('form');
    this.productGrid = document.querySelector('#product-list'); // Produktgrid
    this.filterContainer = document.querySelector('.facets-wrapper'); // Filter-Section
    this.activeFiltersWrapper = document.querySelector('.active-filters'); // Badge-Container

    this.onChange = this.onChange.bind(this);
    this.form.addEventListener('input', this.onChange);

    // Pagination Links
    document.addEventListener('click', this.onClickPagination.bind(this));

    // Entfernen von Badges
    document.addEventListener('click', this.onClickRemoveBadge.bind(this));
  }

  onChange(event) {
    event.preventDefault();
    const formData = new FormData(this.form);
    const searchParams = new URLSearchParams(formData).toString();
    this.renderPage(searchParams, true);
  }

  onClickPagination(event) {
    const link = event.target.closest('a');
    if (!link) return;
    if (link.closest('.pagination')) {
      event.preventDefault();
      const searchParams = link.searchParams ? link.searchParams.toString() : link.search.replace('?', '');
      this.renderPage(searchParams, false);
    }
  }

  onClickRemoveBadge(event) {
    const btn = event.target.closest('.active-filter__remove');
    if (!btn) return;

    const span = btn.closest('.active-filter');
    const paramName = span.dataset.paramName;
    const value = span.dataset.value;

    if (paramName && value) {
      const input = document.querySelector(`#FacetFiltersForm input[name="${paramName}"][value="${value}"]`);
      if (input) input.checked = false;

      this.form.dispatchEvent(new Event('input', { bubbles: true }));
    }
  }

  renderPage(searchParams, resetScroll = false) {
    const url = `${window.location.pathname}?${searchParams}`;
    this.showLoading(true);

    // Offene Filter merken
    const openFacets = Array.from(this.filterContainer.querySelectorAll('details[open]'))
      .map(f => f.dataset.facetKey || f.querySelector('summary')?.innerText.trim());

    const scrollY = window.scrollY;

    fetch(url)
      .then(r => r.text())
      .then(htmlText => {
        const html = new DOMParser().parseFromString(htmlText, 'text/html');

        // Produkte aktualisieren
        const sourceProducts = html.querySelector('#product-list');
        if (sourceProducts && this.productGrid) {
          this.productGrid.innerHTML = sourceProducts.innerHTML;
        }

        // Filter aktualisieren
        const sourceFilters = html.querySelector('.facets-wrapper');
        if (sourceFilters && this.filterContainer) {
          this.filterContainer.innerHTML = sourceFilters.innerHTML;

          // Offene Filter wiederherstellen
          this.filterContainer.querySelectorAll('details').forEach(facet => {
            const key = facet.dataset.facetKey || facet.querySelector('summary')?.innerText.trim();
            if (openFacets.includes(key)) facet.setAttribute('open', true);
          });
        }

        // Aktive Filter Badges aktualisieren
        const sourceBadges = html.querySelector('.active-filters');
        if (sourceBadges && this.activeFiltersWrapper) {
          this.activeFiltersWrapper.innerHTML = sourceBadges.innerHTML;
        }

        // URL aktualisieren
        const newUrl = url.replace(/page=\d+/g, '');
        window.history.pushState({}, '', newUrl);

        // Scroll-Verhalten
        if (resetScroll) this.productGrid.scrollIntoView({ behavior: 'smooth', block: 'start' });
        else window.scrollTo({ top: scrollY });

        this.showLoading(false);
      })
      .catch(e => { console.error(e); this.showLoading(false); });
  }

  showLoading(active) {
    let loader = document.querySelector('#facet-loading');
    if (!loader) {
      loader = document.createElement('div');
      loader.id = 'facet-loading';
      loader.innerHTML = `<div class="facet-spinner"></div>`;
      document.body.appendChild(loader);
    }
    loader.style.display = active ? 'flex' : 'none';
  }
}

customElements.define('facet-filters-form', FacetFiltersForm);

// Event delegation für aktive Filter entfernen
document.addEventListener('click', (event) => {
  const btn = event.target.closest('.active-filter__remove');
  if (!btn) return;

  const span = btn.closest('.active-filter');
  const paramName = span.dataset.paramName;
  const value = span.dataset.value;

  if (paramName && value) {
    // Formular-Checkbox finden und abwählen
    const input = document.querySelector(`#FacetFiltersForm input[name="${paramName}"][value="${value}"]`);
    if (input) input.checked = false;

    // Trigger Change Event für AJAX Reload
    const form = document.querySelector('#FacetFiltersForm');
    form.dispatchEvent(new Event('input', { bubbles: false }));
  }
});